import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.321 12c2.232 0 4.041-1.847 4.041-4.125s-1.809-4.125-4.04-4.125c-2.232 0-4.041 1.847-4.041 4.125S10.089 12 12.32 12m-1.442 1.547c-3.11 0-5.629 2.572-5.629 5.746 0 .528.42.957.938.957h12.267a.95.95 0 0 0 .938-.957c0-3.174-2.52-5.746-5.629-5.746z"
    }, null, -1)
  ]))]))
}
export default { render: render }